import { render, staticRenderFns } from "./Borensbergsrevyn.vue?vue&type=template&id=f1417782"
import script from "./Borensbergsrevyn.vue?vue&type=script&lang=js"
export * from "./Borensbergsrevyn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports